import React from 'react'
import CardUI from '../../../../widgets/layout/CardUI'
import LRTableActionsUI from '../../../../widgets/layout/LRTableActionsUI'
import LRTableBodyUI from '../../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../../widgets/layout/LRTableRowUI'
import IconButtonUI from '../../../../widgets/action/IconButtonUI'
import SpinnerComponentUI from '../../../../components/common/SpinnerComponentUI'
import LoanPropertyUpdateModalSF from './LoanPropertyUpdateModalSF'
import './LoanPropertyList.css'

const LoanPropertyListUI = ({context, propertyList, errorList, loan,
    // modes
    updateMode, selectedProperty, category, categoryLabel,
    // event handlers
    onRefreshClick, onUpdateClick, onCancelClick, onUpdate
  }) =>
  propertyList.length > 0 &&
  <CardUI className='su_l_props g_m_top_100' title={categoryLabel} noUnderline={true}>

    <LRTableBodyUI>
      {
         propertyList.map((property, i) =>
          <LRTableRowUI key={i}
            context={context}
            left={<RowLeftUI context={context} property={property} />}
            right={<RowRightUI property={property} onUpdateClick={onUpdateClick} />}
          />
        )
      }
    </LRTableBodyUI>

    <LoanPropertyUpdateModalSF
      context={context}
      errorList={errorList}
      updateMode={updateMode}
      onCancelClick={onCancelClick}
      onRefreshClick={onRefreshClick}
      selectedProperty={selectedProperty}
      onUpdate={onUpdate}
      loan={loan}
    />
  </CardUI>

  const RowLeftUI = ({context, i, property}) =>
    <div className='g_flex_h g_flex_left'>
      {
        property.propertyCode !== 'term_sheet_special_terms' &&
        <>
          <span className='g_m_right_50'>
            {i}
          </span>
          <span>
            {property.propertyName}<br/>
            {
              property.hint &&
              <span className='g_muted g_small'>{property.hint}</span>
            }
          </span>
        </>
      }
    </div>

  const RowRightUI = ({property, onUpdateClick}) =>
    <div className={`g_flex_h g_m_left_100 g_flex_top g_flex_right
      ${property.propertyCode != 'term_sheet_special_terms' ? 'right1' : ''}`}>
      {
        property.propertyType !== 'boolean_' &&
        <span className='wrap'>{property.propertyValue || property.defaultValue}</span>
      }
      {
        property.propertyType === 'boolean_' &&
        <span>{property.propertyValue != null ? (property.propertyValue === '1' ? 'Yes' : 'No') :
           (property.defaultValue === '1' ? 'Yes' : 'No')}</span>
      }
      <span className='icon icon-pencil g_link_2 g_m_left_50'
        data-property={property.propertyCode} onClick={onUpdateClick} />
    </div>

export default LoanPropertyListUI
